__webpack_require__.p = "/slot-management/";